// extracted by mini-css-extract-plugin
export default {"QuizRoot":"quizRoot_QuizRoot__lsGhq"};